module.exports = __webpack_public_path__ + "img/Interdisciplinary_approach.0f63b688.png";